import React from "react";
import bg from "../../assets/images/slide1.jpg";
import { Link } from "react-router-dom";
const CallToAction = () => {
  return (
    <div>
      <section
        className="relative bg-cover bg-center bg-no-repeat bg-[#00AEFF] text-white"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <div className="bg-black bg-opacity-40">
          <div className="max-w-7xl mx-auto px-6 py-14 flex flex-col lg:flex-row items-center justify-between gap-8">
            {/* Text Content */}
            <div className="text-center lg:text-left">
              <h2 className="text-2xl sm:text-2xl mb-2 md:mb-0  md:text-4xl font-semibold">
                Try our 7 days free trial
              </h2>
              <p className="md:text-base text-[15px] font-semibold  capitalize  text-white ">
                See how we optimize your site’s performances and grow your
                business!
              </p>
            </div>

            {/* Button */}

            <div className="flex flex-col md:flex-row gap-2">
              {/* Phone Button */}
              <a
                href="tel:+919717055088"
                className="flex items-center gap-3 bg-gray-800 text-white font-semibold text-lg px-6 py-3 rounded-full transition duration-300 hover:bg-gray-700"
              >
                {/* <FaPhoneAlt className="text-white" /> */}
                <span>+91- 9717055088</span>
              </a>

              {/* Contact Us Button */}
              <Link
                to="contact-us"
                className="bg-gray-800 hidden md:block text-white font-semibold text-lg px-6 py-3 rounded-full transition duration-300 hover:bg-gray-700"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CallToAction;
